import { useContext } from 'react';
import { NotificationContext } from '../components/NotificationManager';

export const useNotification = () => {
  const context = useContext(NotificationContext);
  
  if (!context) {
    console.error('useNotification must be used within NotificationManager');
    // Return dummy functions if context is not available
    return {
      showSuccess: (msg) => console.log('Success:', msg),
      showError: (msg) => console.error('Error:', msg),
      showWarning: (msg) => console.warn('Warning:', msg),
      showInfo: (msg) => console.info('Info:', msg),
      addNotification: () => {},
      removeNotification: () => {},
    };
  }
  
  return context;
};

export default useNotification;

